import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Riad.css";
import api from "../apiService/api";

const API_URL = api.API_URL + "read_riads&limit=4&page=1"; // Updated API endpoint for riads
const BASE_URL = api.BASE_URL;

const Riad = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

    const [page, setPage] = useState(1);

  const [riads, setRiads] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [riadsPerPage, setRiadsPerPage] = useState(3);
  const [selectedRiad, setSelectedRiad] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Reservation form states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [reservationStatus, setReservationStatus] = useState("idle");
  const [reservationError, setReservationError] = useState(null);

  const [selectedMediaImage, setSelectedMediaImage] = useState({
    index: null,
    image: null,
  });

    const [loadingImages, setLoadingImages] = useState(
      selectedRiad? new Array(selectedRiad.riad_images.length).fill(true) : []
    );
    
  
    const handleImageLoad = (index) => {
      setLoadingImages((prevLoading) => {
        const newLoading = [...prevLoading];
        newLoading[index] = false; // Mark image as loaded
        return newLoading;
      });
    };

  const handleLightboxNav = (direction) => {
    const totalImages = selectedRiad.riad_images.length;
    let newIndex;

    if (direction === "next") {
      newIndex = (selectedMediaImage.index + 1) % totalImages;
    } else if (direction === "prev") {
      newIndex = (selectedMediaImage.index - 1 + totalImages) % totalImages;
    }

    setSelectedMediaImage({
      index: newIndex,
      image: selectedRiad.riad_images[newIndex].filePath,
    });
  };

 
  // useEffect(() => {
  //   const fetchRiads = async () => {
  //     try {
  //       const response = await fetch(`${BASE_URL}index.php?action=read_riads&limit=4&page=${page}`); // Updated endpoint
  //       const data = await response.json();

  //       if (data.success && Array.isArray(data.riads)) {
  //         setRiads(
  //           data.riads.map((riad) => ({
  //             id: riad.id,
  //             riad_name: riad.riad_name,
  //             location: riad.location,
  //             price: riad.price,
  //             description: riad.description,
  //             coverImage: `${riad.cover_image}`,
  //             riad_images: riad.riad_images?.map((image) => ({
  //               filePath: `${image.image_path}`,
  //             })) || [],
  //           }))
  //         );
  //       } else {
  //         setError("Invalid data format");
  //       }
  //     } catch (error) {
  //       setError("");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRiads();
  // }, [page]);


  useEffect(() => {
    const fetchRiads = async () => {
      try {
        const response = await fetch(`${BASE_URL}index.php?action=read_riads&limit=4&page=${page}`);
        const data = await response.json();
  
        if (data.success && Array.isArray(data.riads)) {
          setRiads((prevRiads) => {
            // If first page (page 1), reset the list
            if (page === 1) {
              return data.riads.map((riad) => ({
                id: riad.id,
                riad_name: riad.riad_name,
                location: riad.location,
                price: riad.price,
                description: riad.description,
                coverImage: `${riad.cover_image}`,
                riad_images: riad.riad_images?.map((image) => ({
                  filePath: `${image.image_path}`,
                })) || [],
              }));
            }
  
            // For subsequent pages, append new unique riads
            const newRiads = data.riads
              .filter((riad) => !prevRiads.some((r) => r.id === riad.id))
              .map((riad) => ({
                id: riad.id,
                riad_name: riad.riad_name,
                location: riad.location,
                price: riad.price,
                description: riad.description,
                coverImage: `${riad.cover_image}`,
                riad_images: riad.riad_images?.map((image) => ({
                  filePath: `${image.image_path}`,
                })) || [],
              }));
  
            return [...prevRiads, ...newRiads];
          });
        } else {
          setError("Invalid data format");
        }
      } catch (error) {
        setError("");
      } finally {
        setLoading(false);
      }
    };
  
    fetchRiads();
  }, [page]);

   useEffect(() => {
      if (selectedRiad) {
        setLoadingImages(new Array(selectedRiad.riad_images.length).fill(true));
      }
    }, [selectedRiad]);

  // Adjust riads per page based on screen size
  useEffect(() => {
    const updateRiadsPerPage = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        setRiadsPerPage(1); // Mobile: 1 card
      } else if (width <= 768) {
        setRiadsPerPage(1); // Tablet: 1 card for simplicity
      } else if (width <= 1024) {
        setRiadsPerPage(2); // Larger tablets: 2 cards
      } else {
        setRiadsPerPage(3); // Desktop: 3 cards
      }
    };

    updateRiadsPerPage();
    window.addEventListener("resize", updateRiadsPerPage);

    return () => window.removeEventListener("resize", updateRiadsPerPage);
  }, []);

  // const scrollLeft = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? riads.length - riadsPerPage : prevIndex - 1
  //   );
  // };

  // const scrollRight = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex >= riads.length - riadsPerPage ? 0 : prevIndex + 1
  //   );
  // };


  const scrollLeft = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? riads.length - riadsPerPage : prevIndex - 1
    );
  };
  
  const scrollRight = () => {
    const maxIndex = Math.max(0, riads.length - riadsPerPage);
    
    // If we're at the end, fetch more data
    if (currentIndex >= maxIndex - 1) {
      setPage((prevPage) => prevPage + 1);
    }
    
    // Maintain circular scrolling
    setCurrentIndex((prevIndex) =>
      prevIndex >= maxIndex ? 0 : prevIndex + 1
    );
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setPhoneNumber(value);
  };

  const handleReservationSubmit = async (e) => {
    e.preventDefault();

    if (!selectedRiad) return;

    setReservationStatus("submitting");
    setReservationError(null);

    try {
      const response = await fetch(
        `${BASE_URL}index.php?action=create_riad_reservation`, // Updated endpoint
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            riad_id: selectedRiad.id,
            start_date: startDate,
            end_date: endDate,
            phone_number: phoneNumber,
            name: name,
            status: "pending",
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setReservationStatus("success");
        setStartDate("");
        setEndDate("");
        setPhoneNumber("");
        setName("");
      } else {
        setReservationStatus("error");
        setReservationError(data.message || "Failed to submit reservation");
      }
    } catch (error) {
      setReservationStatus("error");
      setReservationError("Network error. Please try again.");
    }
  };

  // if (loading) return <p>Loading riads...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="riads-container">
      <div className="Rheader-container">
        <h1 className="riads-title">{t("riadsTitle")}</h1> {/* Updated title */}
        <div className="navigation-buttons">
          <button className="Rnav-btn" onClick={isArabic ? scrollRight : scrollLeft}>
            {isArabic ? "→" : "←"}
          </button>
          <button className="Rnav-btn" onClick={isArabic ? scrollLeft : scrollRight}>
            {isArabic ? "←" : "→"}
          </button>
        </div>
      </div>

      <div className="riads-grid">
        {riads.slice(currentIndex, currentIndex + riadsPerPage).map((riad) => (
          <div key={riad.id} className="riad-card">
            <div className="Rimage-container">
              <img src={riad.coverImage} alt={riad.riad_name} className="riad-image" />
              <div className="Rimage-overlay" />
            </div>
            <div className="riad-info">
              <div className="text-content">
                <h3 className="riad-title">{riad.riad_name}</h3>
                <p className="riad-location"><strong>{riad.location}</strong></p>
                <p className="riad-price">{riad.price} MAD</p>
                <p className="riad-description">{riad.description}</p>
              </div>
              <button className="learn-more-btn" onClick={() => setSelectedRiad(riad)}>
                <span className="nav">{isArabic ? "←" : "→"}</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedRiad && (
        <div className="modal-overlay" onClick={() => setSelectedRiad(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedRiad(null)}>×</button>
            <img src={selectedRiad.coverImage} alt={selectedRiad.riad_name} className="modal-image" />
            <h2 className="modal-title">{selectedRiad.riad_name}</h2>
            <p className="modal-location">
              <strong>{t("locationLabel")}</strong> {selectedRiad.location}
            </p>
            <p className="modal-price">
              <strong>{t("priceLabel")}</strong> {selectedRiad.price} MAD
            </p>
            <p className="modal-description">{selectedRiad.description}</p>

            {selectedRiad.riad_images.length > 0 && (
              <div className="media-gallery">
                {selectedRiad.riad_images.map((image, index) => (
              //     <img
              //       key={index}
              //       src={image.filePath}
              //       alt="Riad media"
              //       className="media-image"
              //       onClick={() => setSelectedMediaImage({ index, image: image.filePath })}
              //     />
              //   ))}
              // </div>
              <div key={index} className="media-container">
                    {/* Shimmer effect */}
                    {loadingImages[index] && <div className="shimmer"></div>}

                    {/* Image with onLoad event */}
                    <img
                      src={image.filePath}
                     alt="Riad media"
                      className={`media-image ${loadingImages[index] ? "hidden" : ""}`}
                      onLoad={() => handleImageLoad(index)}
                      onClick={() => setSelectedMediaImage({ index, image: image.filePath })}
                    />
                  </div>
                ))}
              </div>
            )}

            {selectedMediaImage.index !== null && (
              <div
                className="lightbox-overlay"
                onClick={() => setSelectedMediaImage({ index: null, image: null })}
              >
                <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="lightbox-Rnav-btn left"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLightboxNav("prev");
                    }}
                  >
                    ←
                  </button>
                  <img src={selectedMediaImage.image} alt="Enlarged media" className="lightbox-image" />
                  <button
                    className="lightbox-Rnav-btn right"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleLightboxNav("next");
                    }}
                  >
                    →
                  </button>
                  <button
                    className="close-btn"
                    onClick={() => setSelectedMediaImage({ index: null, image: null })}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}

            <div className="rreservation-section">
              <h3>{t("reservationFormTitle", "Make a Reservation")}</h3>
              {reservationStatus === "success" ? (
                <div className="rreservation-success">
                  <p>{t("reservationSuccessMessage", "Your reservation request has been submitted successfully!")}</p>
                  <button
                    className="form-buttonR"
                    onClick={() => setReservationStatus("idle")}
                    style={{ marginTop: "20px", width: "auto", padding: "0 20px" }}
                  >
                    {t("makeAnotherReservation", "Make Another Reservation")}
                  </button>
                </div>
              ) : (
                <form onSubmit={handleReservationSubmit} className="rreservation-form">
                  <div className="date-inputs">
                    <div className="date-field">
                      <label htmlFor="start-date">{t("checkIn", "Check-In")}</label>
                      <input
                        id="start-date"
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="form-dateR"
                        required
                      />
                    </div>
                    <div className="date-field">
                      <label htmlFor="end-date">{t("checkOut", "Check-Out")}</label>
                      <input
                        id="end-date"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="form-dateR"
                        required
                      />
                    </div>
                  </div>
                  <div className="phone-field">
                    <label htmlFor="phone-number">{t("phoneNumber", "Phone Number")}</label>
                    <input
                      id="phone-number"
                      type="tel"
                      value={phoneNumber}
                      onChange={handlePhoneChange}
                      className="form-phoneR"
                      placeholder={t("phonePlaceholder", "Enter your phone number")}
                      required
                    />
                  </div>
                  <div className="phone-field">
                    <label htmlFor="name">{t("name", "Name")}</label>
                    <input
                      id="name"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-phoneR"
                      placeholder={t("namePlaceholder", "Enter your name")}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="form-buttonR"
                    disabled={reservationStatus === "submitting"}
                  >
                    {reservationStatus === "submitting"
                      ? t("submitting", "Submitting...")
                      : t("submitReservation", "Submit Reservation")}
                  </button>
                  {reservationStatus === "error" && (
                    <p className="rreservation-error">{reservationError}</p>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Riad;